module.exports = __webpack_public_path__ + "static/woman_set_8elder.db69badd.svg";